import { faCircleHalfStroke } from '@fortawesome/pro-light-svg-icons/faCircleHalfStroke';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@thinkalpha/ui-core/utils';

/**
 * A color circle that takes in a color class and renders a circle with that color.
 * If the color class is null, it renders a circle with a slash through it.
 * @param colorClassName The color class which should include `fill-${color}` and `text-${color}` for the best effect
 * @param nullClassName The class to apply when the color class is null
 * @param nonNullClassName The class to apply when the color class is not null
 */
interface ColorCircleProps {
    className: string | null;
}

export const ColorCircle = ({ className }: ColorCircleProps) => {
    if (className === null) {
        return <FontAwesomeIcon icon={faCircleHalfStroke} className={cn('h-3 w-3')} fixedWidth />;
    }

    return <FontAwesomeIcon icon={faCircle} className={cn(className, 'h-3 w-3 border-0')} fixedWidth />;
};
